/**
 * The target menu's rows for the townsfolk (lane C0-NPC): "มอบของขวัญ" (N3, shared data/npcAffinity.ts) — a good from
 * the bag (once a day each; what they like raises ความสนิทสนม most) or a little silver — and the person's tier; and a
 * wanderer's open challenge (N4, "รับคำท้า").
 */
import { affinityTierOf, GOODS, npcLifeOf, wanderersOf, type Entity, type PlayerCommand, type World } from '@nine/shared';
import { h } from './dom';

/** The menu rows for a townsperson of the plains (none for anyone else). */
export function lifeMenuItems(
  world: World,
  t: Entity,
  send: (c: PlayerCommand) => void,
  item: (label: string, on: () => void, off?: string, sub?: string) => HTMLButtonElement,
  close: () => void,
  at: { x: number; y: number },
): HTMLButtonElement[] {
  // A wanderer (N4) who has just challenged the player: take it up through the ring's own challenge.
  const dare = wanderersOf(world)?.dare;
  if (dare && dare.id === t.id)
    return [item('รับคำท้า', () => send({ t: 'duelChallenge', id: t.id }), '', 'ไม่รับก็ได้ คำท้าจะหมดไปเอง')].map((b) => {
      b.addEventListener('click', close);
      return b;
    });
  const life = npcLifeOf(world)?.mindOf(t);
  if (!life) return [];
  const tier = affinityTierOf(world, t);
  const far = Math.hypot(t.x - world.player.x, t.y - world.player.y) > 3.4 ? 'เข้าไปใกล้กว่านี้' : '';
  const goods = Object.entries(world.progress.trades.goods).filter(([id, n]) => n > 0 && GOODS[id]);
  return [
    item('มอบของขวัญ', () => picker(t, goods, send, at), far || (goods.length ? '' : 'ไม่มีของในกระเป๋า'), tier ? `สนิทสนม: ${tier.name}` : ''),
    item('มอบ 100 ตำลึง', () => send({ t: 'npcGift', id: t.id, gold: 100 }), far || (world.progress.gold < 100 ? 'ตำลึงไม่พอ' : '')),
  ].map((b) => {
    b.addEventListener('click', close);
    return b;
  });
}

/** The goods in the bag to choose from. */
function picker(t: Entity, goods: [string, number][], send: (c: PlayerCommand) => void, at: { x: number; y: number }): void {
  document.querySelector('.life-gift')?.remove();
  const done = () => m.remove();
  const rows = goods.slice(0, 16).map(([id, n]) => {
    const b = h('button', { type: 'button' }, `${GOODS[id]!.name} ×${n}`);
    b.addEventListener('click', () => {
      send({ t: 'npcGiftItem', id: t.id, good: id });
      done();
    });
    return b;
  });
  const cancel = h('button', { type: 'button' }, 'ยกเลิก');
  cancel.addEventListener('click', done);
  const m = h('div', { class: 'duel-menu life-gift' }, h('div', { class: 'hd', textContent: `มอบของให้${t.name}` }), ...rows, cancel);
  m.style.left = `${Math.min(at.x, window.innerWidth - 230)}px`;
  m.style.top = `${Math.min(at.y, window.innerHeight - 320)}px`;
  document.body.append(m);
}
